export const OptionReservationModeCalcul = {
    Duree: 0,
    DureePersonne: 1,
    Global: 2,
    Gratuite: 3,
    Personne: 4
};

export default OptionReservationModeCalcul;
